import './topBarStyle.css'
export default function TopBar ()
{
    return (
        <div className="topbar-container">
            <img src='logo.png' className='logo' alt='logo'/>
            <span className='faminto-text-logo'>Delícias da Virgínia</span>
        </div>
    )
}